const ROW_ACCENT = {
  green: 'border-l-green-500',
  blue: 'border-l-blue-500',
  none: 'border-l-transparent',
} as const;

const GREEN_STATUSES = new Set<string>(['Validation Requested']);
const BLUE_STATUSES = new Set<string>(['Completed', 'Validated']);

/**
 * Maps a work-order status to its Figma left-border accent colour.
 *
 * Returns a `border-l-*` *colour* only — pair it with `border-l-4` on the cell
 * it is applied to (every row reserves the same 4px so accented and unaccented
 * rows stay aligned). The accent must live on a `<td>`, not the `<tr>`: a row
 * left-border is ignored under `border-collapse: separate` and arbitrated
 * unreliably under `collapse`, which is why it painted inconsistently before.
 */
export function getStatusRowAccent(status: string | null): string {
  if (status === null) return ROW_ACCENT.none;
  if (GREEN_STATUSES.has(status)) return ROW_ACCENT.green;
  if (BLUE_STATUSES.has(status)) return ROW_ACCENT.blue;
  return ROW_ACCENT.none;
}
